
import Categories from '@/graphql/queries/taxonomy/Categories'

export default {
  props: {
    limit: {
      type: Number,
      default: 9
    }
  },
  async fetch() {
    const { data } = await this.$graphql.query({
      clientId: 'eshop',
      query: Categories,
      variables: { first: this.limit }
    })

    this.categories = data.categories || []
  },
  data() {
    return {
      categories: null
    }
  }
}
